import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimesCircle } from "react-icons/fa";
import { privateRoutes } from "constant/route/privateRoutes";
import { useAuth } from "hooks‬/Auth";

const PaymentFail: React.FC = () => {
  const navigate = useNavigate();
  const { fetchSubcriptionDetail, companyDetailFormDashboarding } = useAuth();

  useEffect(() => {
    fetchSubcriptionDetail();
    companyDetailFormDashboarding();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(privateRoutes.dashboard);
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-4">
      <FaTimesCircle size={120} color="red" className="mb-4" />
      <h1 className="text-danger mb-3">Payment Failed!</h1>
      <p className="text-muted fs-2 mb-4">
        Something went wrong. You’ll be redirected to the dashboard shortly.
      </p>
      <button
        className="btn btn-danger d-flex align-items-center"
        onClick={() => navigate(privateRoutes.dashboard)}
      >
        <FaTimesCircle className="me-2" />
        Go to Dashboard
      </button>
    </div>
  );
};

export default PaymentFail;
